import { AbstractDisplayObjectClip } from "./AbstractDisplayObjectClip";
import { IGoodgameClip } from "./IGoodgameClip";

import { GoodgameBitmapEngine } from "../GoodgameBitmapEngine";
import { ClipColor } from "../components/ClipColor";

export class GoodgameDisplayObjectClip extends AbstractDisplayObjectClip implements IGoodgameClip {
    constructor(source: Object, clipColor: ClipColor[], fps: number = 24, autoPlay: boolean = true, hasSubLayer: boolean = false, animationColorChange: boolean = false) {
        super();
        this.animationManager = GoodgameBitmapEngine.instance.animationManager;
        this.clipColor = clipColor;
        this.targetFps = fps;
        this._running = autoPlay;
        this.hasSubLayer = hasSubLayer;
        this.animationColorChange = animationColorChange;
        this._startFrame = 1;
        this.initCurrentClip(source);
    }

    //TODO: @HTML5 - because of different inheritance chain this method needs to be implemented here
    // normally IEventDispatcher is implemented on every DisplayObject
    once(type: string, listener: Function, thisObject?: any, useCapture?: boolean, priority?: number): void {
    }

    public dispose(): void {
        super.dispose();
    }
}
